import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang( '@shining3d/xl-design-order' );
export const langMap = new Map([
        ['zh-cn', 'cn'],
        ['en-us', 'en'],
        ['ja-jp', 'jp']
    ]);
export const orderStatusType = {
    waitAccept: 'primary',
    inDesign: 'primary',
    waitDesign: 'primary',
    waitCheck: 'success',
    pause: 'danger',
    waitRecover: 'danger',
    waitRedesign: 'danger',
    cancel: 'info',
    complete: 'info',
    redesignComplete: 'info',
};

export const serviceObj = {
	repair: {
		icon: 'xiufu',
		name: $t( 'design.case.repair' ),
		svg: true
	},
	orthodontic: {
		icon: 'zhengji-weixuan',
		name: $t( 'design.case.orthodontic' )
	},
	implant: {
		icon: 'zhongzhi-weixuan',
		name: $t( 'design.case.implant' )
	},
	other: {
		icon: 'qita-weixuan',
		name: $t( 'design.other' )
	},
	aesthetics: {
		icon: 'a-yewumeixue',
		name: $t( 'design.case.aesthetics' ),
		svg: true
	},
	maxillofacial: {
		icon: 'hemian',
		name: $t( 'design.case.maxillofacial' ),
		svg: true
	},
	removableDenture: { icon: 'jubukezhaiyichi', name: $t( 'design.case.removableDenture' ), svg: true }
};
export const timeMap = {
    second: 's',
    minute: 'm',
    hour: 'h',
    day: 'd',
    '': ''
};
export function useNotSrcFileList() {
	// AccuDesign返回模型文件,临时冠返回模型文件,IBT返回模型文件 不展示
	const notSrcFileList = ['_model.', 'tempCrown.', 'ibt.', '_splint.'];
	const notFileNameList = ['_model', '_tempCrown', '_ibt', '_splint'];
	return { notSrcFileList, notFileNameList };
}

// 设计偏好的表格联动关系映射
export const preferItemShowMap = {
	//  修复-3D模型 壁厚
	'3DModel_wallThickness01': { // 需要联动展示的formItem的key
		showKey: '3DModel_modelType01', // 根据showKey表单项选择进行联动
    	showValue: ['hollowIntegrated','hollowPlugUnplug']// 当showKey的值为 'one' 时展示，其他不展示
	},
	// 修复-3D模型 插拔间隙	
	'3DModel_InsertionGap01': {
		showKey: '3DModel_modelType01',
    	showValue: ['hollowPlugUnplug','solidPlugUnplug']
	},
	// 种植-3D种植模型: 壁厚
	'3DImplantModel_wallThickness02': {
		showKey: '3DImplantModel_modelType02',
		showValue: ['hollowIntegrated']
	},
	// 'typeJ：正畸-夜磨牙垫'
	'nightguard_occlusionGap': {
		showKey: 'nightguard_openBite',
		showValue: 'y'
	},
	// typeM: 种植全冠
	'implantCrown_gingivalThickness': {
		showKey: 'implantCrown_whetherGingival',
		showValue: 'yes'
	},
	// typeQ: 自动化设计3D模型 壁厚
	'automated3DModel_offset': {
		showKey: 'automated3DModel_3DModel_modelType01', // 根据showKey表单项选择进行联动
    	showValue: ['hollowIntegrated']
	},
	// typeQ: 自动化设计3D模型 是否设计蜂窝
	'automated3DModel_isHoneycomb': {
		showKey: 'automated3DModel_3DModel_modelType01', // 根据showKey表单项选择进行联动
    	showValue: ['hollowIntegrated']
	}
};
// 设计偏好的商品配置关系映射表
export const preferProductMap = {
	// 普通全冠（Crown）
	'prod_crown': {
		imageType: 'A' // 配图类型
	},
	// 内嵌体
	'prod_inlay': {
		imageType: 'A'
	},
	// 高嵌体
	'prod_onlay': {
		imageType: 'A'
	},
	// 内冠
	'prod_coping': {
		imageType: 'A'
	},
	// 贴面
	'prod_veneer': {
		imageType: 'A'
	},
	// 桩核
	'prod_post': {
		imageType: 'A'
	},
	// 微笑设计
	'prod_DSD': {
		imageType: 'B'
	},
	// 3D模型
	'prod_simple_3D_model': {
		imageType: 'C'
	},
	// 种植全冠
	'prod_implant_crown': {
		imageType: 'M',
		showScanningRod: true,
		showDashedBorder: true
	},
	// 种植内冠
	'prod_implant_coping': {
		imageType: 'D',
		showScanningRod: true,
		showDashedBorder: true
	},
	// 3D种植模型
	'prod_3D_implant_model': {
		imageType: 'E',
		showScanningRod: true,
		showDashedBorder: true
	},
	// 个性化基台
	'prod_customized_implant_abutments': {
		imageType: 'F',
		showScanningRod: true,
		showDashedBorder: true
	},
	// 马泷桥
	'prod_malo_bridge': {
		imageType: 'G',
		showScanningRod: true
	},
	// 种植导板
	'prod_guided_implant_surgery': {
		imageType: 'H',
		showScanningRod: true	
	},
	// 保持器
	'prod_splint': {
		imageType: 'I',
	},
	// 夜磨牙垫
	'prod_nightguard': {
		imageType: 'J',
	},
	// 全口活动义齿
	'prod_denture': {
		imageType: 'K',
	},
	// 活动钢托
	'prod_partial_removable_denture': {
		imageType: 'L',
	},
	// allonx
	'prod_implant_allonx': {
		imageType: 'R',
		showScanningRod: true
	},
	// 自动化设计普通全冠
	'prod_automated_crown': {
		imageType: 'N',
	},
	// 自动化设计3D模型
	'prod_automated_simple_3d_model': {
		imageType: 'Q',
	},
	// 自动化设计保持器
	'prod_automated_splint': {
		imageType: 'O',
	},
	// 自动化设计夜磨牙垫
	'prod_automated_nightguard': {
		imageType: 'P',
	}	
}

// 支付卡类型
export const cardList = [
	{
		label: $t('design.pointCard.gift') || '礼品卡',
		value: 'giftCard'
	},
	{
		label: $t('design.pointCard.debit') || '储值卡',
		value: 'debitCard'
	}
];